import React, {useEffect, useState} from "react";
import Pagination from "../../../components/pagination";
import {useStateValue} from "../../../states/StateProvider";
import {formatDate} from "../../../helper/formatDate";
import ExcelExport from "./excelFormat";
import {IoMdArrowDropdown} from "react-icons/io";
import TableComponent from "./tableComponent";
import ClipLoader from 'react-spinners/ClipLoader';
import DgapiView from "./dgapiView";
import ProjectTafelView from "./projekt-tafelView";
import FirmenprojekteView from "./firmenprojekteView";
import FirmenprojekteDGGView from "./firmenprojekteDGGView";
import BeratungView from "./beratungView";
import VertriebView from "./vertriebView";
import {RiArrowDownSFill, RiArrowUpSFill} from "react-icons/ri";
import SmartTooltip from "../../../components/SmartTooltip";

const BestandListDataSection = ({
                                    users,
                                    loading,
                                    printPDFRef,
                                    headers,
                                    portal,
                                    printing,
                                    sortColumn,
                                    sortMethod,
                                    total,
                                    PageSize,
                                    filterID,
                                    filter,
                                    view,
                                    views,
                                    isOpen,
                                    toggleDropdown,
                                    dropdownRef,
                                    setViewName,
                                    clearFilters,
                                    hasFilter,
                                    setPrintState,
                                    loadingViews,
                                    user,
                                    url,
                                    count,
                                    rows,
                                    portalChanged,
                                    mileStoneNumber,
                                    pendingFilter,
                                    setPendingFilter,
                                    pendingFilterID,
                                    setPendingFilterID,
                                    applyFilters,
                                    hasPendingChanges,
                                    setHasPendingChanges
                                }) => {
    const [{pageBestand, dateFilter}, dispatch] = useStateValue();
    const searChableFields = view === 'Firmenprojekte' ? [1, 2, 3, 4, 5, 7, 18] : [1, 2, 4, 5, 6, 7]
    const checkboxFields = (view === 'Firmenprojekte' || view === 'Projekt-Tafel') ? [] : view === 'Auswertung Vertrieb' ? [8, 9, 10, 11, 12, 13, 14] : view === 'Auswertung DGAPI' ? [8, 9, 10, 11, 12, 13, 14] : [8, 9, 10, 11]
    const sortableFields = [1, 2, 3, 4, 5, 6, 7, 8, 10, 11, 12, 13, 14, 15, 16, 18]
    const [selectedView, setSelectedView] = useState(views[0]?.viewName);

    useEffect(() => {
        if (filter.h === null) {
            dispatch({type: "SET_SORTBESTANDFILTER", item: {...filter, h: 1}})
            dispatch({type: "SET_SORTBESTANDFILTERID", item: {...filterID, h: 111}})
        }

        if (filter.k === null) {
            dispatch({type: "SET_SORTBESTANDFILTER", item: {...filter, k: 1}})
            dispatch({type: "SET_SORTBESTANDFILTERID", item: {...filterID, k: 114}})
        }
    }, [filter]);

    useEffect(() => {
        const isValid = mileStoneNumber && Number.isInteger(Number(mileStoneNumber));
        if (!isValid) return;

        const isDgg = portal === 'dgg';
        const key = isDgg ? 'e' : 'g';
        const colId = isDgg ? 5 : 7;

        if (!filter[key]) {
            dispatch({
                type: "SET_SORTBESTANDFILTER",
                item: { ...filter, [key]: Number(mileStoneNumber) }
            });
            dispatch({
                type: "SET_SORTBESTANDFILTERID",
                item: { ...filterID, [key]: colId }
            });
        }

        const parsed = Number(mileStoneNumber);

        const shouldEnableAbgeschlossene =
            (portal === 'dgg' && parsed === 13) ||
            (portal === 'ruv' && parsed === 18);

        if (shouldEnableAbgeschlossene && filter.i !== 1) {
            dispatch({
                type: "SET_SORTBESTANDFILTER",
                item: { ...filter, i: 1 }
            });
            dispatch({
                type: "SET_SORTBESTANDFILTERID",
                item: { ...filterID, i: 112 }
            });
        }
    }, [mileStoneNumber, filter, filterID, dispatch]);


    function ascSort(id) {
        dispatch({type: "SET_SORTBESTANDCOLUMN", item: id})
        dispatch({type: "SET_SORTBESTANDMETHOD", item: 'asc'})
    }

    function descSort(id) {
        dispatch({type: "SET_SORTBESTANDCOLUMN", item: id})
        dispatch({type: "SET_SORTBESTANDMETHOD", item: 'desc'})
    }

    // Update pending filter instead of global filter - filters are applied when user clicks "Filter starten" or presses Enter
    function enableFilter(id, val) {
        setHasPendingChanges(true);
        if (id === 1) {
            setPendingFilter(prev => ({...prev, a: val}));
            setPendingFilterID(prev => ({...prev, a: 1}));
        }
        if (id === 2) {
            setPendingFilter(prev => ({...prev, b: val}));
            setPendingFilterID(prev => ({...prev, b: 2}));
        }
        if (id === 3) {
            setPendingFilter(prev => ({...prev, c: val}));
            setPendingFilterID(prev => ({...prev, c: 3}));
        }
        if (id === 4) {
            setPendingFilter(prev => ({...prev, d: val}));
            setPendingFilterID(prev => ({...prev, d: 4}));
        }
        if (id === 5) {
            setPendingFilter(prev => ({...prev, e: val}));
            setPendingFilterID(prev => ({...prev, e: 5}));
        }
        if (id === 6) {
            setPendingFilter(prev => ({...prev, f: val}));
            setPendingFilterID(prev => ({...prev, f: 6}));
        }
        if (id === 7) {
            setPendingFilter(prev => ({...prev, g: val}));
            setPendingFilterID(prev => ({...prev, g: 7}));
        }
        if (id === 111) {
            setPendingFilter(prev => ({...prev, h: val}));
            setPendingFilterID(prev => ({...prev, h: 111}));
        }
        if (id === 112) {
            setPendingFilter(prev => ({...prev, i: val}));
            setPendingFilterID(prev => ({...prev, i: 112}));
        }
        if (id === 113) {
            setPendingFilter(prev => ({...prev, j: val}));
            setPendingFilterID(prev => ({...prev, j: 113}));
        }
        if (id === 114) {
            setPendingFilter(prev => ({...prev, k: val}));
            setPendingFilterID(prev => ({...prev, k: 114}));
        }
        if (id === 18) {
            setPendingFilter(prev => ({...prev, l: val}));
            setPendingFilterID(prev => ({...prev, l: 115}));
        }
        if (id === 116) {
            setPendingFilter(prev => ({...prev, m: val}));
            setPendingFilterID(prev => ({...prev, m: 116}));
        }
    }

    // Handle Enter key press to apply filters
    function handleKeyDown(e) {
        if (e.key === 'Enter') {
            e.preventDefault();
            applyFilters();
        }
    }

    function enableDateFilter(id, value) {
        dispatch({type: "SET_DATEFILTER", item: {id: id, value: value}})
        dispatch({type: "SET_SORTBESTANDCOLUMN", item: id})
        dispatch({type: "SET_SORTBESTANDMETHOD", item: 'desc'})
    }

    useEffect(() => {
        if (portal === 'dgg' && view ==='Projekt-Tafel') {
            portalChanged()
            setSelectedView(views[0]?.viewName);
        }
    }, [portal, views, portalChanged]);

    const handleViewChange = (e) => {
        setSelectedView(e.target.value);
        setViewName(e.target.value)
    };

    return (
        <div>
            <div className="bg-white pt-3 pb-1 px-3">
                <div className="flex flex-wrap justify-between items-center gap-4">

                    {/* Left side: Export buttons */}
                    <div className="flex flex-wrap items-center gap-3">
                        <ExcelExport
                            all
                            url={url}
                            count={count}
                            rows={rows}
                            title={'Excel Export'}
                            loading={loading}
                            len={users?.length}
                            portal={portal}
                            view={view}
                        />
                        <ExcelExport
                            Gesamt
                            url={url}
                            count={count}
                            rows={rows}
                            title={'Excel Export Gesamt'}
                            loading={loading}
                            len={users?.length}
                            portal={portal}
                            view={view}
                        />
                    </div>

                    {/* Right side: Filter buttons and checkboxes */}
                    <div className="flex items-center gap-3">
                        {!loading && (
                            <button
                                disabled={!hasFilter}
                                onClick={clearFilters}
                                className={`rounded-md px-4 py-2 bg-cancel text-sm font-medium text-white opacity-80 ${
                                    !hasFilter ? 'bg-white text-text' : ''
                                }`}
                            >
                                {hasFilter ? 'Such-Filter zurücksetzen' : 'Kein Suche Filter'}
                            </button>
                        )}
                        {/* Filter starten button - triggers filter application */}
                        {!loading && (
                            <button
                                disabled={!hasPendingChanges}
                                onClick={applyFilters}
                                className={`rounded-md px-4 py-2 text-sm font-medium text-white ${
                                    hasPendingChanges ? 'bg-mainBlue hover:bg-blue-600' : 'bg-gray-300 cursor-not-allowed'
                                }`}
                            >
                                Filter starten
                            </button>
                        )}
                        
                        <div className="flex items-center gap-4">
                        <label className="flex items-center cursor-pointer text-grey text-sm">
                            Projekt-Filter:
                        </label>
                        <label className="flex items-center cursor-pointer text-grey text-sm">
                            <input
                                type="checkbox"
                                name="inaktive"
                                className="mr-2"
                                disabled={loading}
                                checked={pendingFilter?.k === 1}
                                onChange={(e) => enableFilter(114, e.target.checked ? 1 : 0)}
                            />
                            vorbereitete
                        </label>

                        <label className="flex items-center cursor-pointer text-grey text-sm">
                            <input
                                type="checkbox"
                                name="laufende"
                                className="mr-2"
                                disabled={loading}
                                checked={pendingFilter?.h === 1}
                                onChange={(e) => enableFilter(111, e.target.checked ? 1 : 0)}
                            />
                            laufende
                        </label>

                        <label className="flex items-center cursor-pointer text-grey text-sm">
                            <input
                                type="checkbox"
                                name="beendete"
                                className="mr-2"
                                disabled={loading}
                                checked={pendingFilter?.i === 1}
                                onChange={(e) => enableFilter(112, e.target.checked ? 1 : 0)}
                            />
                            abgeschlossene
                        </label>

                        <label className="flex items-center cursor-pointer text-grey text-sm">
                            <input
                                type="checkbox"
                                name="abgesagte"
                                className="mr-2"
                                disabled={loading}
                                checked={pendingFilter?.j === 1}
                                onChange={(e) => enableFilter(113, e.target.checked ? 1 : 0)}
                            />
                            abgesagte
                        </label>

                        <span className="mx-2 text-gray-300">|</span>

                        <label className="flex items-center cursor-pointer text-grey text-sm">
                            <input
                                type="checkbox"
                                name="demoMuster"
                                className="mr-2"
                                disabled={loading}
                                checked={pendingFilter?.m === 1}
                                onChange={(e) => enableFilter(116, e.target.checked ? 1 : 0)}
                            />
                            Demo/Muster
                        </label>
                        </div>
                    </div>
                </div>
            </div>


            <div className="flex flex-col">
                <div className="overflow-x-auto sm:-mx-6 lg:-mx-8">
                    <div className="py-2 inline-block min-w-full sm:px-6 lg:px-8"
                         style={{minHeight: '60vh'}}>
                        <div className="overflow-hidden pt-1">
                            {
                                (users?.length === 0 && !loading) &&
                                <div className='centerItemsAbsolute'>
                                    <h2 className='text-2xl text-text font-bold'>
                                        Es wurden keine Daten zu Ihrer Suche gefunden.
                                    </h2>
                                    <h2 className='text-2xl text-text font-bold'>
                                        Bitte prüfen Sie ggf. die Filter-Einstellungen.
                                    </h2>
                                </div>
                            }
                            <div className='overflow-x-hidden table-wrp block' ref={printPDFRef}
                                 style={{maxHeight: '58vh'}}>
                                <table className='min-w-full text-left bg-white' id="table-to-xls">
                                    <thead
                                        className="whitespace-nowrap bg-white border-y border-silver border-x-0 sticky top-0">
                                    <tr>
                                        {
                                            !loading &&
                                            headers.map(header => (
                                                <SmartTooltip
                                                    key={header.id}
                                                    content={header.mouseOver}
                                                    placement="auto"
                                                    maxWidth={320}
                                                >
                                                    <th scope="col"
                                                        className="text-sm text-grey pl-1.5"
                                                        style={{minWidth: header.width, width: header.width}}
                                                    >
                                                        <span className='flex justify-left'>
                                                            <span
                                                                className={`mt-1.5 text-center xl:h-fit lg:h-14 ${sortColumn === header.id && 'text-mainBlue'}`}
                                                            >
                                                                {header.title}
                                                            </span>
                                                            <span hidden={printing}
                                                                  className={`${!(sortableFields.includes(header.id)) && 'opacity-0'}`}>
                                                                <p className={`cursor-pointer ${sortColumn === header.id && sortMethod === 'asc' ? 'text-mainBlue' : ''}`}
                                                                   onClick={() => ascSort(header.id)}
                                                                >
                                                                    <RiArrowUpSFill size='22px'/>
                                                                </p>
                                                                <p className={`-mt-3.5 cursor-pointer ${sortColumn === header.id && sortMethod === 'desc' ? 'text-mainBlue' : ''}`}
                                                                   onClick={() => descSort(header.id)}
                                                                >
                                                                    <RiArrowDownSFill size='22px'/>
                                                                </p>
                                                            </span>
                                                        </span>
                                                        <span
                                                            className={`${!(searChableFields.includes(header.id)) && 'hideDiv'}`}>
                                                            <input className='w-full h-2 px-2 py-3 search mb-4' type='text'
                                                                   hidden={printing}
                                                                   maxLength="50"
                                                                   value={
                                                                       header.id === 1 ? (pendingFilter?.a || '')
                                                                           : header.id === 2 ? (pendingFilter?.b || '')
                                                                               : header.id === 3 ? (pendingFilter?.c || '')
                                                                                   : header.id === 4 ? (pendingFilter?.d || '')
                                                                                       : header.id === 5 ? (pendingFilter?.e || '')
                                                                                           : header.id === 6 ? (pendingFilter?.f || '')
                                                                                               : header.id === 18 ? (pendingFilter?.l || '')
                                                                                                   : (pendingFilter?.g || '')
                                                                   }
                                                                   onChange={(e) => enableFilter(header.id, e.target.value)}
                                                                   onKeyDown={handleKeyDown}
                                                                   placeholder='Suche... (Enter drücken)'
                                                            />
                                                        </span>
                                                        <span
                                                            className={`${!(checkboxFields.includes(header.id)) && 'hideDiv'} cursor-pointer`}>
                                                                <input className='w-full mb-4' type='radio'
                                                                       hidden={printing}
                                                                       checked={dateFilter.id === header.id && dateFilter.value}
                                                                       onChange={(e) => enableDateFilter(header.id, e.target.checked)}
                                                                />
                                                        </span>
                                                        <span className={`${(searChableFields.includes(header.id) || checkboxFields.includes(header.id)) && 'hideDiv'}`}>
                                                          <input className='w-full h-2 px-2 py-3 mb-4 opacity-0' type='text'
                                                                 disabled
                                                          />
                                                        </span>
                                                    </th>
                                                </SmartTooltip>
                                            ))
                                        }
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {
                                        loading &&
                                        <tr className='centerItemsAbsolute'>
                                            <td>
                                                <div className='flex flex-col items-center justify-center gap-4'>
                                                    <p className='text-whiteDarker text-2xl font-medium'>Firmenprojekte werden geladen...</p>
                                                    <ClipLoader size={50} color={'#b4b4b4'}/>
                                                </div>
                                            </td>
                                        </tr>
                                    }
                                    {
                                        (!loading && view === 'Firmenprojekte' && portal==='ruv') ?
                                            users?.map((u, index) => (
                                                <FirmenprojekteView
                                                    key={index}
                                                    FirmaKurz={u.FirmaKurz}
                                                    FirmaID={u.FP_ID}
                                                    FBKBank={u.FBKBank}
                                                    ZustBerater={u.ZustFKB}
                                                    Bank={u.Bank}
                                                    RegioBereich={u.RegioBereich}
                                                    MA={u.MA}
                                                    PStatus={u.PStatus}
                                                    Note={u.Note}
                                                    date={u.Datum}
                                                    WV={u.WV}
                                                    printing={printing}
                                                    portal={portal}
                                                    vertrieb={u.Vertrieb}
                                                />
                                            ))   :
                                            (!loading && view === 'Firmenprojekte' && portal==='dgg') ?
                                                users?.map((u, index) => (
                                                    <FirmenprojekteDGGView
                                                        key={index}
                                                        FirmaKurz={u.FirmaKurz}
                                                        FirmaID={u.FP_ID}
                                                        FBKBank={u.ZustADM}
                                                        ZustBerater={u.Firma}
                                                        Bank={u.MA}
                                                        RegioBereich={u.ZustVP}
                                                        MA={u.MA}
                                                        PStatus={u.PStatus}
                                                        Note={u.Note}
                                                        date={u.Datum}
                                                        WV={u.WV}
                                                        printing={printing}
                                                        portal={portal}
                                                        vertrieb={u.Vertrieb}
                                                    />
                                                ))
                                                : (!loading && view === 'Projekt-Tafel') ?
                                                    users?.map((u, index) => (
                                                        <ProjectTafelView
                                                            key={index}
                                                            FirmaID={u.FP_ID}
                                                            FirmaKurz={u.FirmaKurz}
                                                            Firmenname={u.Firmenname}
                                                            ZustandigerFKB={u.ZuständigerFKB}
                                                            BD={u.BD}
                                                            FD={u.FD}
                                                            DGAPIKAM={u.DGAPIKAM}
                                                            MA={u.MA}
                                                            DL_Kzl_vollst={u.DL_Kzl_vollst}
                                                            Projtd_vollst={u.Projtd_vollst}
                                                            Projtd_abge={u.Projtd_abge}
                                                            AA_FA_hin={u.AA_FA_hin}
                                                            StSvGA_erst={u.StSvGA_erst}
                                                            ArTfGA_erst={u.ArTfGA_erst}
                                                            ProjStart={u.ProjStart}
                                                            MAV_an_FKB={u.MAV_an_FKB}
                                                            MAB_fertig={u.MAB_fertig}
                                                            Note={u.Note}
                                                            printing={printing}
                                                            portal={portal}
                                                        />
                                                    )) : (!loading && view === 'Auswertung DGAPI' && portal==='ruv') ?
                                                        users?.map((u, index) => (
                                                            <DgapiView
                                                                key={index}
                                                                FirmaID={u.FP_ID}
                                                                FirmaKurz={u.FirmaKurz}
                                                                Firmenname={u.Firmenname}
                                                                ZustandigerFKB={u.ZuständigerFKB}
                                                                BD={u.BD}
                                                                FD={u.FD}
                                                                DGAPIKAM={u.DGAPIKAM}
                                                                MA={u.MA}
                                                                Auftrag_DL_Paket={u.Auftr_DL_P}
                                                                DL_Kanzl_Auftrag_versandt={u.DL_KA_vers}
                                                                DL_Kanzl_Auftrag_zurück={u.DL_KA_zur}
                                                                FP_Grundl_abgeschlossen={u.FP_Grdl_abg}
                                                                FP_Def_vollständig={u.FP_Def_vollst}
                                                                CIB_abgeschlossen={u.CIB_abg}
                                                                FP_Freischaltung={u.FP_Freischltg}
                                                                Note={u.Note}
                                                                printing={printing}
                                                                portal={portal}
                                                            />
                                                        )): (!loading && view === 'Auswertung DGAPI' && portal==='dgg') ?
                                                            users?.map((u, index) => (
                                                                <DgapiView
                                                                    key={index}
                                                                    FirmaID={u.FP_ID}
                                                                    FirmaKurz={u.FirmaKurz}
                                                                    Firmenname={u.Firmenname}
                                                                    ZustandigerFKB={u.Zustaendiger_Closer}
                                                                    BD={u.ADM}
                                                                    FD={u.KGSL}
                                                                    DGAPIKAM={u.DG_KAM}
                                                                    MA={u.MA}
                                                                    Auftrag_DL_Paket={u.Auftr_DL_P}
                                                                    DL_Kanzl_Auftrag_versandt={u.DL_KA_vers}
                                                                    DL_Kanzl_Auftrag_zurück={u.DL_KA_zur}
                                                                    FP_Grundl_abgeschlossen={u.FP_Grdl_abg}
                                                                    FP_Def_vollständig={u.FP_Def_vollst}
                                                                    CIB_abgeschlossen={u.CIB_abg}
                                                                    FP_Freischaltung={u.FP_Freischltg}
                                                                    Note={u.Note}
                                                                    printing={printing}
                                                                    portal={portal}
                                                                />
                                                            )) : (!loading && view === 'Auswertung Beratung' && portal==='ruv') ?
                                                                users?.map((u, index) => (
                                                                    <BeratungView
                                                                        key={index}
                                                                        FirmaID={u.FP_ID}
                                                                        FirmaKurz={u.FirmaKurz}
                                                                        Firmenname={u.Firmenname}
                                                                        ZustandigerFKB={u.ZuständigerFKB}
                                                                        BD={u.BD}
                                                                        FD={u.FD}
                                                                        DGAPIKAM={u.DGAPIKAM}
                                                                        MA={u.MA}
                                                                        FP_Freischaltung={u.FP_Freischaltung}
                                                                        FP_Briefing_erfolgt={u.FP_Briefing_erfolgt}
                                                                        FP_Start_fix={u.FP_Start_fix}
                                                                        FP_Abschluss_Umsetzung={u.FP_Abschluss_Umsetzung}
                                                                        Note={u.Note}
                                                                        printing={printing}
                                                                        portal={portal}
                                                                    />
                                                                )): (!loading && view === 'Auswertung Beratung' && portal==='dgg') ?
                                                                    users?.map((u, index) => (
                                                                        <BeratungView
                                                                            key={index}
                                                                            FirmaID={u.FP_ID}
                                                                            FirmaKurz={u.FirmaKurz}
                                                                            Firmenname={u.Firmenname}
                                                                            ZustandigerFKB={u.Zustaendiger_Closer}
                                                                            BD={u.ADM}
                                                                            FD={u.KGSL}
                                                                            DGAPIKAM={u.DG_KAM}
                                                                            MA={u.MA}
                                                                            FP_Freischaltung={u.FP_Freischaltung}
                                                                            FP_Briefing_erfolgt={u.FP_Briefing_erfolgt}
                                                                            FP_Start_fix={u.FP_Start_fix}
                                                                            FP_Abschluss_Umsetzung={u.FP_Abschluss_Umsetzung}
                                                                            Note={u.Note}
                                                                            printing={printing}
                                                                            portal={portal}
                                                                        />
                                                                    ))
                                                                    : (!loading && view === 'Auswertung Vertrieb' && portal==='ruv') ?
                                                                        users?.map((u, index) => (
                                                                            <VertriebView
                                                                                key={index}
                                                                                FirmaID={u.FP_ID}
                                                                                FirmaKurz={u.FirmaKurz}
                                                                                Firmenname={u.Firmenname}
                                                                                ZustandigerFKB={u.ZuständigerFKB}
                                                                                BD={u.BD}
                                                                                FD={u.FD}
                                                                                DGAPIKAM={u.DGAPIKAM}
                                                                                MA={u.MA}
                                                                                Überl_R_V={u.Überl_R_V}
                                                                                Ersttermin={u.Ersttermin}
                                                                                Analyseb_vollst={u.Analyseb_vollst}
                                                                                SK_Termin={u.SK_Termin}
                                                                                iForm_DGAPI_AM={u.iForm_DGAPI_AM}
                                                                                Auftrag_DL_Paket={u.Auftrag_DL_Paket}
                                                                                iForm_Termin={u.iForm_Termin}
                                                                                Note={u.Note}
                                                                                printing={printing}
                                                                                portal={portal}
                                                                            />
                                                                        )) : (!loading && view === 'Auswertung Vertrieb'  && portal==='dgg') &&
                                                                        users?.map((u, index) => (
                                                                            <VertriebView
                                                                                key={index}
                                                                                FirmaID={u.FP_ID}
                                                                                FirmaKurz={u.FirmaKurz}
                                                                                Firmenname={u.Firmenname}
                                                                                ZustandigerFKB={u.Zustaendiger_Closer}
                                                                                BD={u.ADM}
                                                                                FD={u.KGSL}
                                                                                DGAPIKAM={u.DG_KAM}
                                                                                MA={u.MA}
                                                                                Überl_R_V={u.Überl_R_V}
                                                                                Ersttermin={u.Ersttermin}
                                                                                Analyseb_vollst={u.Analyseb_vollst}
                                                                                SK_Termin={u.SK_Termin}
                                                                                iForm_DGAPI_AM={u.iForm_DGAPI_AM}
                                                                                Auftrag_DL_Paket={u.Auftrag_DL_Paket}
                                                                                iForm_Termin={u.iForm_Termin}
                                                                                Note={u.Note}
                                                                                printing={printing}
                                                                                portal={portal}
                                                                            />
                                                                        ))
                                    }
                                    </tbody>
                                </table>
                                <div className={`${!printing && 'hideDiv'} text-center mt-6`}>
                                    <p className='font-bold text-mainBlue'>{total} Zeilen gedruckt</p>
                                    <p className='text-mainBlue'>{'Firmenprojekte -' + formatDate(new Date(), true)}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={`centerItemsRelative mt-5 mb-2 pb-2 ${loading && 'opacity-0'}`}>
                    {
                        users?.length > 0 &&
                        <Pagination
                            className="pagination-bar"
                            currentPage={pageBestand}
                            totalCount={total}
                            pageSize={PageSize}
                            onPageChange={pageNo => dispatch({
                                type: "SET_PAGE_BESTAND",
                                item: pageNo
                            })}
                        />
                    }
                </div>
            </div>
        </div>
    )
}

export default BestandListDataSection
